/**
 * @generated SignedSource<<5716bc89ea6de4e121e26fe9b108795a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type webSearchPill_AtlassianConversationAssistantAgent_WebSearchPillListDataComponent_scenarioListRef$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly isWebSearchEnabledForScenarioAndOrganization: boolean | null;
    } | null;
  }> | null;
  readonly " $fragmentType": "webSearchPill_AtlassianConversationAssistantAgent_WebSearchPillListDataComponent_scenarioListRef";
};
export type webSearchPill_AtlassianConversationAssistantAgent_WebSearchPillListDataComponent_scenarioListRef$key = {
  readonly " $data"?: webSearchPill_AtlassianConversationAssistantAgent_WebSearchPillListDataComponent_scenarioListRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"webSearchPill_AtlassianConversationAssistantAgent_WebSearchPillListDataComponent_scenarioListRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "webSearchPill_AtlassianConversationAssistantAgent_WebSearchPillListDataComponent_scenarioListRef",
  "selections": [
    {
      "concreteType": "AgentStudioScenariosEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isWebSearchEnabledForScenarioAndOrganization"
            }
          ]
        }
      ]
    }
  ],
  "type": "AgentStudioScenariosResult"
};

(node as any).hash = "2459049e3e60a20fe09b9b75f07cb1b3";

export default node;
